/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, of: NonNullable<unknown> }} Workout_Superset_PositionInputs */

const en_us2_workout_superset_position = /** @type {(inputs: Workout_Superset_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Superset · ${i?.n} of ${i?.of}`)
};

const pt_br2_workout_superset_position = /** @type {(inputs: Workout_Superset_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Superset · ${i?.n} de ${i?.of}`)
};

const es_419_workout_superset_position = /** @type {(inputs: Workout_Superset_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Superserie · ${i?.n} de ${i?.of}`)
};

const pt_pt2_workout_superset_position = /** @type {(inputs: Workout_Superset_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Superset · ${i?.n} de ${i?.of}`)
};

const fr_fr2_workout_superset_position = /** @type {(inputs: Workout_Superset_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Superset · ${i?.n} sur ${i?.of}`)
};

const de_de2_workout_superset_position = /** @type {(inputs: Workout_Superset_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supersatz · ${i?.n} von ${i?.of}`)
};

const it_it2_workout_superset_position = /** @type {(inputs: Workout_Superset_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Superset · ${i?.n} di ${i?.of}`)
};

/**
* | output |
* | --- |
* | "Superset · {n} of {of}" |
*
* @param {Workout_Superset_PositionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_superset_position = /** @type {((inputs: Workout_Superset_PositionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Superset_PositionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_superset_position(inputs)
	if (locale === "es-419") return es_419_workout_superset_position(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_superset_position(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_superset_position(inputs)
	if (locale === "de-DE") return de_de2_workout_superset_position(inputs)
	if (locale === "it-IT") return it_it2_workout_superset_position(inputs)
	return en_us2_workout_superset_position(inputs)
});
export { workout_superset_position as "workout.superset_position" }